<template>
    <inertia-head>
        <title>{{ title }}</title>
        <meta v-if="initialMetaDesc" name="description" :content="initialMetaDesc">
        <meta property="og:image" :content="`${$page.props.baseUrl}/assets/frontend/hero.jpg`" />
    </inertia-head>

    <breadcrumb>
        <breadcrumb-item>
            <inertia-link href="/">Hem</inertia-link>
        </breadcrumb-item>
        <breadcrumb-item :last="!initialCategory">
            <inertia-link v-if="initialCategory" :href="`${headings[this.companyTypeFilter].url}`">
                {{ headings[this.companyTypeFilter].label }}
            </inertia-link>
            <span v-if="!initialCategory">{{ headings[this.companyTypeFilter].label }}</span>
        </breadcrumb-item>
        <breadcrumb-item v-if="initialCategory" :last="initialSubcategory ? false : true">
            <span v-if="initialCategory && !initialSubcategory">{{ initialCategory.name }}</span>
            <inertia-link :href="`${headings[this.companyTypeFilter].categoryUrl()}`" v-if="initialSubcategory">{{ initialCategory.name }}</inertia-link>
        </breadcrumb-item>
        <breadcrumb-item v-if="initialSubcategory" :last="true">
            {{ initialSubcategory.name }}
        </breadcrumb-item>
    </breadcrumb>

    <main role="main" class="main search-results campaign-by-cat page-content-padding">
        <div class="container">
            <h1 class="page-heading" v-if="!initialCategory && !initialSubcategory">{{ headings[this.companyTypeFilter].label }}</h1>
            <h2 v-if="initialCategory && !initialSubcategory" class="page-heading">
                {{ headings[this.companyTypeFilter].label }}
            </h2>

            <h1 v-if="initialCategory && !initialSubcategory" class="page-heading">
                {{ initialCategory.name }}
            </h1>

            <h2 v-if="initialSubcategory" class="page-heading">
                {{ initialCategory.name }}
            </h2>

            <h1 v-if="initialCategory && initialSubcategory" class="page-heading">
                {{ initialSubcategory.name }}
            </h1>

            <p class="text-dark px-2" v-if="initialCategory" style="margin-top: 25px;">
                <expandable-text :max-length="100" :disabled="!$isMobile">{{ initialCategory.description }}</expandable-text>
            </p>

            <p class="text-dark px-2 mx-auto" style="max-width: 800px;margin-top: 25px;" v-else>
                <slot name="heading"></slot>
            </p>

            <select class="mt-2 badge badge-secondary text-center me-2" @change="companyTypeFilterChanged" v-model="companyTypeFilter" v-if="!hideTypeFilter">
                <option class="text-center" value="all">E-handel + Lokala</option>
                <option value="webshops">Visa endast E-Handel</option>
                <option value="locals">Visa endast Lokala</option>

                <option value="city" v-if="$page.component.startsWith('AllCampaigns/City')">Visar {{ city.name }}</option>
            </select>

            <select class="mt-2 badge badge-secondary text-center me-md-2" @change="cityChanged" :disabled="!['all', 'locals', 'city'].includes(companyTypeFilter)" v-if="!hideCityFilter">
                <option value="Hela landet" class="text-center">Hela landet</option>
                <option v-for="c in cities" :value="c.slug" :selected="c.name === city?.name">{{ c.name }}</option>
            </select>

            <select class="mt-2 badge badge-secondary" @change="categoryChanged">
                <option :value="null">Välj kategori</option>
                <option
                    v-for="category in categories.filter(c => c.parent_id === null)"
                    :selected="(initialCategory && initialCategory.slug === category.slug)"
                    :value="category.slug">
                    {{ category.name }}
                </option>
            </select>

            <select class="mt-2 ms-md-2 badge badge-secondary" style="width: 170px;" @change="subcategoryChanged" :disabled="getInitialCategory().childrens.length === 0">
                <option :value="null">Alla underkategorier</option>
                <option
                    v-for="subcategory in categories.filter(c => c.parent_id === initialCategory?.id)"
                    :selected="(initialSubcategory && initialSubcategory.slug === subcategory.slug)"
                    :value="subcategory.slug">
                    {{ subcategory.name }}
                </option>
            </select>

            <!-- <div class="mt-3"> -->
                <!-- <Popper offsetDistance="12" style="display:inline-block;">
                    <a class="text-red sortmenu d-inline-block">
                        Sortera på
                    </a>

                    <template #content>
                        <ul>
                            <li>
                                <a href="javascript:void(0)" @click="sort = 'popularity', refresh()">Popularitet</a>
                            </li>
                            <li>
                                <a href="javascript:void(0)" @click="sort = 'latest', refresh()">Nyast</a>
                            </li>
                            <li>
                                <a href="javascript:void(0)" @click="sort = 'alphabetical', refresh()">A-Ö</a>
                            </li>
                        </ul>
                    </template>
                </Popper> -->
            <!-- </div> -->

            <div class="list-result-container mt-3">
                <div class="list-result container px-1 py-1">
                    <div class="row gx-3 mt-2">
                        <div class="col-6 col-md-3 mb-4" v-for="campaign in campaigns" :key="campaign.id">
                            <campaign-item :campaign="campaign" :banner="campaign.banner" />
                        </div>
                    </div>

                    <infinite-loading @in-view="infiniteHandler">
                        <template #loading>
                            Laddar...
                        </template>
                    </infinite-loading>
                </div>
            </div>
        </div>
    </main>
</template>

<style>
    .has-subcategory {
        font-size: 28px;
    }
</style>

<script>
    import Popper from 'vue3-popper';
    import CategoryFilter from '@/components/CategoryFilter.vue';
    import { router } from '@inertiajs/vue3';

    export default {
        inject: ['$isMobile'],
        props: {
            hideTypeFilter: {
                type: Boolean,
                default: false,
            },
            hideCityFilter: {
                type: Boolean,
                default: false,
            },
            data: Object,
            paginator: Object,
            city: Object,
            initialCategory: Object|null,
            initialSubcategory: Object|null,
            initialTitle: String|null,
            initialMetaDesc: String|null,
            categoryTitle: String|null,
            companyTypeFilter: {
                type: String,
                default: 'all',
            }
        },
        components: { Popper, CategoryFilter },
        data() {
            return {
                campaigns: [...this.data],
                campaignsPaginator: this.paginator,
                results: [],
                sort: 'latest',
                highlights: [],

                headings: {
                    all: {
                        label: `Alla rabatter`,
                        url: `/kampanjer`,
                        categoryUrl: () => {
                            return `/${this.initialCategory.slug}`;
                        }
                    },
                    webshops: {
                        label: `E-Handel`,
                        url: `/online`,
                        categoryUrl: () => {
                            return `/online/${this.initialCategory.slug}`;
                        }
                    }
                },

                routes: {
                    'all': {
                        category: (category) => {
                            return category ?
                                `/${category.slug}` :
                                `/kampanjer`;
                        },
                        subcategory: (subcategory) => {
                            return (subcategory && this.initialCategory) ?
                                `/${this.initialCategory.slug}/${subcategory.slug}` :
                                `/${this.initialCategory.slug}`;
                        }
                    },
                    'webshops': {
                        category: (category) => {
                            return category ?
                                `/online/${category.slug}` :
                                `/online`;
                        },
                        subcategory: (subcategory) => {
                            return (subcategory && this.initialCategory) ?
                                `/online/${this.initialCategory.slug}/${subcategory.slug}` :
                                `/online/${this.initialCategory.slug}`;
                        }
                    },
                    'locals': {
                        category: (category) => {
                            return category ?
                                `/lokala/${category.slug}` :
                                `/lokala`;
                        },
                        subcategory: (subcategory) => {
                            return (subcategory && this.initialCategory) ?
                                `/lokala/${this.initialCategory.slug}/${subcategory.slug}` :
                                `/lokala/${this.initialCategory.slug}`;
                        }
                    },
                    'city': {
                        category: (category) => {
                            return category ?
                                `/kampanjer/stad/${this.city.slug}/${category.slug}` :
                                `/kampanjer/stad/${this.city.slug}`;
                        },
                        subcategory: (subcategory) => {
                            return (subcategory && this.initialCategory) ?
                                `/kampanjer/stad/${this.city.slug}/${this.initialCategory.slug}/${subcategory.slug}` :
                                `/kampanjer/stad/${this.city.slug}/${this.initialCategory.slug}`;
                        }
                    },
                }
            };
        },
        computed: {
            title () {
                return this.buildTitleWithCategories(this.initialTitle);
            },
            cities() {
                return this.$page.props.cities;
            },
            categories() {
                return this.$page.props.categories;
            }
        },
        methods: {
            getInitialCategory () {
                return (this.initialCategory !== null) ? this.initialCategory : { childrens: [] };
            },

            buildTitleWithCategories (initialTitle) {
                const category = this.initialCategory;
                const subcategory = this.initialSubcategory;
                const c = subcategory ?? category;

                if (c && this.categoryTitle) {
                    return this.categoryTitle.replace('|CATEGORY|', c.name);
                }

                if (c) {
                    initialTitle += ` ${c.name}`;
                }

                return initialTitle;
            },

            companyTypeFilterChanged (val) {
                var value = val.target.value;

                if (value === 'locals') {
                    router.visit(`/${this.$page.props.currentCity.slug}`);
                } else if (value === 'webshops') {
                    router.visit('/online' + this.buildCategoriesUrl());
                } else if (value === 'all') {
                    router.visit('/kampanjer' + this.buildCategoriesUrl());
                }
            },

            getDefinedRoutesByKey (key) {
                var routes = [];

                for (const route in this.routes) {
                    routes.push(this.routes[route][key]);
                }

                return routes;
            },

            categoryChanged (e) {
                const category = this.categories.find((c) => c.slug === e.target.value);

                router.visit(this.routes[this.companyTypeFilter].category(category));
            },

            subcategoryChanged (e) {
                const subcategory = this.getInitialCategory().childrens.find((c) => c.slug === e.target.value);

                router.visit(this.routes[this.companyTypeFilter].subcategory(subcategory));
            },

            hasInitialCategory () {
                return this.initialCategory && this.initialCategory.name && this.initialCategory.slug;
            },

            buildCategoriesUrl () {
                let url = '';

                if (this.hasInitialCategory()) {
                    url += `/${this.initialCategory.slug}`;
                }

                if (this.hasInitialCategory() && this.initialSubcategory) {
                    url += `/${this.initialSubcategory.slug}`;
                }

                return url;
            },

            cityChanged (event) {
                if (event.target.value === 'Hela landet') {
                    router.visit('/lokala' + this.buildCategoriesUrl());
                } else {
                    router.visit(`/${event.target.value}` + this.buildCategoriesUrl());
                }
            },

            getCampaigns (loadMore = false) {
                let url = `${this.campaignsPaginator.next_page_url}`;

                return axios.get(url);
            },

            infiniteHandler($state) {
                if (!this.campaignsPaginator.next_page_url) {
                    $state.complete();
                    return;
                }

                 this.getCampaigns().then(response => {
                    this.campaigns = this.campaigns.concat(response.data.data);
                    this.campaignsPaginator = response.data.paginator;

                    if (this.campaignsPaginator.current_page === this.campaignsPaginator.last_page) {
                        $state.complete();
                    } else {
                        $state.loaded();
                    }
                });
            },
        },
    }
</script>
